module.exports = __webpack_public_path__ + "assets/home_white.f9458bd7.svg";